import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MaterialModule } from "../../../../shared";
import { JustificationDialogComponent } from "../../../../shared/justification-dialog/justification-dialog.component";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import { TreeComponent } from "../../../../shared/tree/tree.component";

@Component({
    selector: 'app-view-template',
    imports: [MaterialModule, MatTreeModule, MatIconModule, TreeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './view-template.component.html',
    styleUrls: ['./view-template.component.scss']
})
export class ViewTemplateComponent{
  data = inject(MAT_DIALOG_DATA);

  public dialogRef= inject(MatDialogRef<JustificationDialogComponent>);
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "view-template";

  constructor() {
    const data = this.data;

    this.data = data;
  }

  public closeSlider(){
    this.dialogRef.close();
  }

  public buildTemplateId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join('-');
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return this.slugify(value);
    }
    return '00';
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }

}
